import { useMemo } from 'react';
import { IAllSuppliers } from 'src/services/useGetOnlineAndOfflineSuppliers';
import { ReviewDocumentResponse } from 'src/services/useReviewDocumentApi';
import { ReviewPoResponse } from 'src/services/useReviewPoApi';
import { IOcrResult } from '../../InvoiceScanManagerContext';
import { code } from '../GetColor';
import useCreateDocumentValidations from './useCreateDocumentValidation';
import useDocumentValidationMessage from './useDocumentValidationMessage';
import usePoValidationMessage from './usePoValidationMessage';

export interface ValidationMessages {
  documentValidationMessage: { message: string; type: code };
  poValidationMessage: { message: string; type: code };
  confirmPopUpMessage: string[];
}

const useReviewDocumentPanelValidation = (
  docNumber: IOcrResult,
  poNumber: IOcrResult,
  selectedSupplier: IAllSuppliers,
  initialReviewDocValidation: ReviewDocumentResponse,
  reviewDocumentValidations: ReviewDocumentResponse,
  reviewPoValidations: ReviewPoResponse,
  initialLoading: boolean,
  isReviewDocumentLoading: boolean,
  isReviewPoLoading: boolean,
  isReviewPanelLoading: boolean,
  reviewPoError: string | null,
  reviewDocumentError: string | null
): ValidationMessages => {
  const documentMessage = useDocumentValidationMessage(
    docNumber.value,
    reviewDocumentValidations,
    selectedSupplier,
    isReviewDocumentLoading,
    initialLoading,
    reviewDocumentError
  );

  const poMessage = usePoValidationMessage(
    poNumber?.value,
    reviewPoValidations,
    isReviewPoLoading,
    initialLoading,
    reviewPoError
  );

  const { popUpMessage } = useCreateDocumentValidations({
    initialReviewDocValidation,
    reviewDocumentValidations,
    poNumber,
    reviewPoValidations,
    docNumber,
    selectedSupplier,
    isReviewPanelLoading,
  });

  const errors = useMemo(
    () => ({
      documentValidationMessage: documentMessage,
      poValidationMessage: poMessage,
      confirmPopUpMessage: popUpMessage,
    }),
    [documentMessage, poMessage, popUpMessage]
  );

  return errors;
};

export default useReviewDocumentPanelValidation;
